var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "home" },
    [
      _c("div", { staticClass: "side" }, [
        _c(
          "div",
          { staticClass: "side-main" },
          [
            _vm.isPC
              ? _c("recent-works-list", {
                  staticClass: "side-content",
                  attrs: { limit: 3, "is-pc": _vm.isPC },
                })
              : _vm._e(),
            _vm.isPC
              ? _c("contest-notification", {
                  staticClass: "side-content",
                  attrs: { contests: _vm.contests },
                })
              : _vm._e(),
            _c(
              "div",
              { staticClass: "analytics" },
              [
                _c("writing-data", { staticClass: "side-content" }),
                _vm.isConnectedNolaNovel
                  ? _c("nola-novel-data", { staticClass: "side-content" })
                  : _vm._e(),
              ],
              1
            ),
            _c("banner-list", {
              staticClass: "side-content",
              attrs: { banner: _vm.banner },
            }),
            !_vm.isPC
              ? _c("recent-works-list", {
                  staticClass: "side-content",
                  attrs: { limit: 1, "is-pc": _vm.isPC },
                })
              : _vm._e(),
          ],
          1
        ),
        _c("div", { staticClass: "side-spacer" }),
        _c("div", { staticClass: "side-links-wrapper" }, [
          _c("div", { staticClass: "side-links-divider" }),
          _c("ul", { staticClass: "side-links" }, [
            _c("li", [
              _c("a", { attrs: { href: "/terms", target: "_blank" } }, [
                _vm._v(_vm._s(_vm.$t("common.termsOfService"))),
              ]),
            ]),
            _c("li", [
              _c("a", { attrs: { href: "/privacy", target: "_blank" } }, [
                _vm._v(_vm._s(_vm.$t("common.privacyPolicy"))),
              ]),
            ]),
            _c("li", [
              _c(
                "a",
                {
                  attrs: {
                    href: "/specifiedCommercialTransactionsAct",
                    target: "_blank",
                  },
                },
                [
                  _vm._v(
                    _vm._s(_vm.$t("common.specifiedCommercialTransactionsAct"))
                  ),
                ]
              ),
            ]),
            _c("li", [
              _c(
                "a",
                { attrs: { href: "/paymentServicesAct", target: "_blank" } },
                [_vm._v(_vm._s(_vm.$t("common.paymentServicesAct")))]
              ),
            ]),
            _c("li", [
              _c("a", { attrs: { href: _vm.help, target: "_blank" } }, [
                _vm._v(_vm._s(_vm.$t("common.helpAndContact"))),
              ]),
            ]),
            _c("li", [
              _c(
                "a",
                {
                  attrs: {
                    href: "https://indent.co.jp/",
                    target: "_blank",
                    rel: "noopener noreferrer",
                  },
                },
                [_vm._v(_vm._s(_vm.$t("common.companyInfo")))]
              ),
            ]),
          ]),
        ]),
      ]),
      _vm.showHomeIntroSlides
        ? _c("HomeIntroSlides", {
            staticClass: "home-intro-slides-area",
            on: { dismissed: _vm.onHomeIntroSlidesDismissed },
          })
        : _vm._e(),
      _c("novel-list", {
        key: "novel-list",
        ref: "novelList",
        staticClass: "novel-list",
        on: {
          changeLoading: _vm.changeLoading,
          "import-end": _vm.importEnd,
          "import-start": _vm.importStart,
        },
      }),
      _c("div", { staticClass: "sp-links-wrapper" }, [
        _c("div", { staticClass: "side-links-divider" }),
        _c("ul", { staticClass: "side-links" }, [
          _c("li", [
            _c("a", { attrs: { href: "/terms", target: "_blank" } }, [
              _vm._v(_vm._s(_vm.$t("common.termsOfService"))),
            ]),
          ]),
          _c("li", [
            _c("a", { attrs: { href: "/privacy", target: "_blank" } }, [
              _vm._v(_vm._s(_vm.$t("common.privacyPolicy"))),
            ]),
          ]),
          _c("li", [
            _c(
              "a",
              {
                attrs: {
                  href: "/specifiedCommercialTransactionsAct",
                  target: "_blank",
                },
              },
              [
                _vm._v(
                  _vm._s(_vm.$t("common.specifiedCommercialTransactionsAct"))
                ),
              ]
            ),
          ]),
          _c("li", [
            _c(
              "a",
              { attrs: { href: "/paymentServicesAct", target: "_blank" } },
              [_vm._v(_vm._s(_vm.$t("common.paymentServicesAct")))]
            ),
          ]),
          _c("li", [
            _c("a", { attrs: { href: _vm.help, target: "_blank" } }, [
              _vm._v(_vm._s(_vm.$t("common.helpAndContact"))),
            ]),
          ]),
          _c("li", [
            _c(
              "a",
              { attrs: { href: "https://indent.co.jp/", target: "_blank" } },
              [_vm._v(_vm._s(_vm.$t("common.companyInfo")))]
            ),
          ]),
        ]),
      ]),
      _vm.isLoading
        ? _c("MaskedLoading", { staticClass: "loading" })
        : _vm._e(),
      _vm.showImportTutorial
        ? _c("ImportTutorialDialog", {
            attrs: {
              close: () => {
                _vm.showImportTutorial = false
              },
              "is-novel-created": _vm.isNovelCreated,
            },
            on: {
              "onboarding-import-clicked": _vm.onboardingImportClicked,
              "onboarding-skip-clicked": _vm.onboardingSkipClicked,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }